import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '../color-mode';

type Props = {
  width?: number;
  fill?: string;
};

export const ModalCloseIcon = ({ width = 20, fill = 'none' }: Props) => {
  const { colorMode } = useColorMode();
  const iconColor = colorMode === 'dark' ? 'white' : 'black';
  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}px`}
      height={`${width}px`}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <g clipPath="url(#clip0_2066_8051)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM10.0008 8.82149L7.05448 5.87521L5.87597 7.05372L8.82224 10L5.87597 12.9463L7.05448 14.1248L10.0008 11.1785L12.947 14.1248L14.1255 12.9463L11.1793 10L14.1255 7.05372L12.947 5.87521L10.0008 8.82149Z"
          fill={iconColor}
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_2066_8051">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </chakra.svg>
  );
};
